export default __webpack_public_path__ + "static/media/Roboto-Regular.1cf75563.woff";